function singleArticle() {
	const main = document.querySelector('main.subpage.single-article');
	if (!main) return;

	console.log('single article');

	const topSwiper = main.querySelector('.top-single-swiper');

	new Swiper(topSwiper, {
		spaceBetween: 32,
	});
}
